import { Project } from "interfaces";

import * as flowConfig from "./config";

export interface NotebookAnalysisProject extends Project {
  data_files: {
    "dissolution-data": string;
    [unitOp: string]: string;
  };
  meta_data: {
    ipqas: { [key: string]: string[] };
    "notebook-counts": { notebook: string; count: number }[];
    "product-params": string[];
    "unit-ops-sizes": { [unitOps: string]: number };
    dissolution?: {
      columns: {
        indexer: string;
        mean_area: string;
        rsd_mean: string;
        time_columns: string[];
      };
      dissolution_params: {
        baths: { [value: string]: number };
        components: { [value: string]: number };
        templates: { [value: string]: number };
        rpm: { [value: string]: number };
        disso_mediums: { [value: string]: number };
      };
      counts: {
        error_profiles: {
          time: number;
          decreasing: number;
          "invalid-values": number;
          "total-errors": number;
        }[];
        starting_profiles: number;
        starting_experiments: number;
        final_experiments: number;
        "experiments-with-no-formulations-data": number;
        "profiles-with-no-formulations-data": number;
        total_errors: number;
      };
      "unit-ops": {
        [unitOps: string]: {
          experiment_count: number;
          profile_count: number;
          process_param_mapper: { [origColumnName: string]: string };
        };
      };
    };
  };
}

export const projectIsNotebookAnalysis = (
  project: Project
): project is NotebookAnalysisProject => project.flow === flowConfig.FLOW_NAME;
